module.exports = __webpack_public_path__ + "static/img/jdk01.38a4150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/car/jdk01.png
// module id = RBsP
// module chunks = 37